import { render } from "./ShelterMemoPanel.vue?vue&type=template&id=22ba1063&scoped=true"
import script from "./ShelterMemoPanel.vue?vue&type=script&lang=js"
export * from "./ShelterMemoPanel.vue?vue&type=script&lang=js"

import "./ShelterMemoPanel.vue?vue&type=style&index=0&id=22ba1063&scoped=true&lang=css"

import exportComponent from "/Users/myeonghoonjeon/git/pawinhand_shelter_manager/PawinhandAPIServer/front/pawinhand_shelter_manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ba1063"]])

export default __exports__